import React from 'react'
import copy from 'copy-to-clipboard'

import { Dropdown } from '@sketch/components'

import { routes } from '@sketch/modules-common'
import { useToast } from '@sketch/toasts'

interface CopyLinkProps {
  shareIdentifier: string
  frameUUID?: string
}

const CopyLink: React.FC<CopyLinkProps> = ({
  shareIdentifier: shareID,
  frameUUID,
}) => {
  const { showToast } = useToast()

  let routePath = null
  if (frameUUID) {
    routePath = routes.FRAME.create({
      shareID,
      frameUUID,
    })
  } else {
    routePath = routes.SHARE_VIEW.create({
      shareID,
    })
  }
  const link = `${window.location.origin}${routePath}`

  return (
    <Dropdown.Item
      onClick={() => {
        copy(link)
        showToast('Link copied')
      }}
    >
      Copy Link
    </Dropdown.Item>
  )
}

export default CopyLink
